/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Object Distribution component for Capacity Evaluation

Author: Deimos Space UK

Version: 1.0
*/
import React from "react";
import { Row, Button, Card, CardBody } from "reactstrap";

export default function ObjectDistribution() {
  return (
    <Card className="widget-flat mt-4 ">
    <CardBody>
    <Row >
      <h4 style={{color:'#003247'}} className="header-title float-left col " >OBJECT DISTRIBUTION</h4>
      <Button style={{background:'#003247'}}   className="float-right"><i className="uil  uil-down-arrow "></i></Button>
      </Row>
     
    </CardBody>
  </Card>
  );
}
